export default __webpack_public_path__ + "static/aircraftManagement_300x200-0c0d5a2c9c19e8e61a840c357997e405.jpg";